const messages = {
  approved: 'Approved',
  cancelled: 'Cancelled',
  changeStatus: 'Change Status',
  emailBrand: 'Send email to Brand',
  emailRetailer: 'Send email to Retailer',
  notes: 'Notes',
  pending: 'Pending',
  selectOne: 'Select one',
  selectOption: 'Select an option to change your order status',
  shipped: 'Shipped',
  update: 'Update',
}

export default messages
